import Vue, {
  computed,
  getCurrentInstance
} from 'vue'

import type {
  WritableComputedRef
} from 'vue'

import VueI18n from 'vue-i18n'

let i18nInstance = VueI18n

const createI18n = (options?: VueI18n.I18nOptions): VueI18n => {
  // @ts-expect-error TS2739: Type 'VueI18n' is missing the following properties from type
  i18nInstance = new VueI18n(options)
  // @ts-expect-error TS2740: Type 'typeof VueI18n' is missing the following properties
  return i18nInstance
}

export interface Composer {
  locale: WritableComputedRef<string>
  t: typeof VueI18n.prototype.t
  tc: typeof VueI18n.prototype.tc
  te: typeof VueI18n.prototype.te
  d: typeof VueI18n.prototype.d
  n: typeof VueI18n.prototype.n
}

/**
 * shamefully stolen from
 * https://github.com/intlify/vue-i18n-composable/blob/master/src/index.ts
 */
const useI18n = () => {
  if (!i18nInstance) throw new Error('vue-i18n not initialized')

  const i18n = i18nInstance

  const instance = getCurrentInstance()
  const vm = instance?.proxy ?? instance ?? new Vue({})

  const locale:WritableComputedRef<string> = computed({
    get() {
      // @ts-expect-error TS2339: Property 'locale' does not exist on type 'typeof VueI18n'.
      return i18n.locale ?? process.env.VUE_APP_I18N_LOCALE
    },
    set(v) {
      // @ts-expect-error TS2339: Property 'locale' does not exist on type 'typeof VueI18n'.
      i18n.locale = v
    }
  })

  return {
    locale,
    // @ts-expect-error TS2339: Property '$t' does not exist on type
    t: vm.$t.bind(vm),
    // @ts-expect-error TS2339: Property '$t' does not exist on type
    tc: vm.$tc.bind(vm),
    // @ts-expect-error TS2339: Property '$tc' does not exist on type
    d: vm.$d.bind(vm),
    // @ts-expect-error TS2339: Property '$te' does not exist on type
    te: vm.$te.bind(vm),
    // @ts-expect-error TS2339: Property '$n' does not exist on type
    n: vm.$n.bind(vm)
  }
}

export {
  useI18n
}
